export default __webpack_public_path__ + "media/images/fancybox/fancybox-y-4421bfdb697e2fc7a1686514c2cef913.png";